
const DisplayFxRateParamsService = (() => {
    let displayParams ;
    const defaultFxDisplayParameters = {
        initialDisplayFxRate: true,
        displayFxRate: true,
        displaySendAmount: true,
        displayNoCountryOnDropdown: true
    };
    return {
        getDisplayProp: key => displayParams[key],
        getDisplayParams: () => displayParams,
        setDisplayParams: (pageParams = {}, evergageParam = {}) => {
            if(!displayParams)
                displayParams = {
                    ...defaultFxDisplayParameters,
                    ...pageParams,
                    ...evergageParam
                };
        }
    }
})();